"use client";

import React from "react";
import { Lightbulb, Rocket, ShieldCheck, Cpu, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  icon: Lightbulb,
  title: "Логопед-дефектолог",
  description: "Развитие речи, коррекция звукопроизношения и работа с когнитивными функциями в игровой и профессиональной форме для детей с особенностями развития."
}, {
  icon: Rocket,
  title: "Спортивная реабилитация",
  description: "Индивидуальные программы физического развития, направленные на укрепление мышечного корсета, координацию движений и общую мобильность."
}, {
  icon: ShieldCheck,
  title: "Иппотерапия",
  description: "Уникальный метод реабилитации с помощью верховой езды, способствующий физическому восстановлению и эмоциональной гармонизации ребенка."
}, {
  icon: Cpu,
  title: "Психологическая помощь",
  description: "Профессиональная поддержка для детей и родителей, направленная на социальную адаптацию, снятие стресса и укрепление семейных связей."
}];
function ServiceItem({
  service,
  index
}: {
  service: typeof services[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <div data-section-id="160225" ref={ref} data-index={index} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <Card className="flex flex-col sm:flex-row items-start gap-6 p-6 sm:p-8 hover:shadow-lg transition-all duration-300 border-border/60 bg-card/50 backdrop-blur-sm">
        <div className="bg-primary/10 p-4 rounded-2xl shrink-0 ring-1 ring-primary/20">
          <service.icon className="size-8 text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-bold mb-3 text-foreground font-default">{service.title}</h3>
          <p className="text-muted-foreground leading-relaxed font-default">{service.description}</p>
        </div>
      </Card>
    </div>;
}
export default function ServicesAndInnovations() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return;
}